import TRANSLATION_ACCESSIBILITY_TH from './accessibility/translation';
import TRANSLATION_BOOKING_TH from './booking/translation';
import TRANSLATION_EVENTS_TH from './events/translation';
import TRANSLATION_EXPERIENCES_TH from './experiences/translation';
import TRANSLATION_FORM_TH from './form/translation';
import TRANSLATION_LANDING_PAGES_TH from './landingPages/translation';
import TRANSLATION_RESERVE_TH from './reserve/translation';
import TRANSLATION_SIGNIN_TH from './signin/translation';
import TRANSLATION_DATES_TH from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_TH,
  ...TRANSLATION_BOOKING_TH,
  ...TRANSLATION_DATES_TH,
  ...TRANSLATION_EVENTS_TH,
  ...TRANSLATION_EXPERIENCES_TH,
  ...TRANSLATION_FORM_TH,
  ...TRANSLATION_LANDING_PAGES_TH,
  ...TRANSLATION_RESERVE_TH,
  ...TRANSLATION_SIGNIN_TH,
};
